import React from 'react';
import { Link } from 'react-router-dom';
import { useBusinessData } from '../../context/BusinessContext';
import SocialMediaLinks from './SocialMediaLinks';
import '../../css/Hero.css';

const Hero = () => {
  const { loading, getData, getImageUrl } = useBusinessData();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // Get hero background image from JSON
  const heroImage = getImageUrl('images.backgrounds.hero', 'hero-bg.jpg');
  
  // Get configured hero buttons
  const heroButtons = getData('ui.home.heroButtons', [
    // Default buttons if configuration is missing
    { text: 'Our Services', link: '/services', type: 'primary' },
    { text: 'Contact Us', link: '/contact', type: 'secondary' }
  ]);
  
  // Create inline style for background image
  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('${heroImage}')`
  };

  return (
    <div className="hero" style={heroStyle}>
      <div className="hero-content">
        <h1>{getData('tagline', 'Growing Your Business with Innovative Solutions')}</h1>
        <p>{getData('description', 'We help businesses transform their ideas into reality with cutting-edge strategies and technologies.')}</p>
        <div className="hero-buttons">
          {heroButtons.map((button, index) => (
            <Link 
              key={index} 
              to={button.link} 
              className={`btn ${button.type === 'primary' ? 'btn-primary' : 'btn-secondary'}`}
            >
              {button.text}
            </Link>
          ))}
        </div>
        {/* Only show social media if heroSocialMedia is configured */}
        {getData('ui.home.heroSocialMedia', null) && (
          <SocialMediaLinks 
            variant="hero" 
            allowedPlatforms={getData('ui.home.heroSocialMedia', [])} 
          />
        )}
      </div>
    </div>
  );
};

export default Hero;